import CSV_IMG_FILE from "../../../assets/images/files/csv-100.png"
import PDF_IMG_FILE from "../../../assets/images/files/pdf-100.png";
import GIF_IMG_FILE from "../../../assets/images/files/gif-100.png";
import MP3_IMG_FILE from "../../../assets/images/files/mp3-100.png";
import WAV_IMG_FILE from "../../../assets/images/files/wav-100.png";
import JPG_IMG_FILE from "../../../assets/images/files/jpg-100.png";
import JSON_IMG_FILE from "../../../assets/images/files/json-100.png";
import DOC_IMG_FILE from "../../../assets/images/files/doc-100.png";


export const getFilePreviewIcon = (filename) => {
  const ext = filename.split(".").pop().toLowerCase();

  const map = {
    csv: CSV_IMG_FILE,
    pdf: PDF_IMG_FILE,
    gif: GIF_IMG_FILE,
    mp3: MP3_IMG_FILE,
    wav: WAV_IMG_FILE,
    jpg: JPG_IMG_FILE,
    jpeg: JPG_IMG_FILE,
    png: JPG_IMG_FILE,
    json: JSON_IMG_FILE,
    doc: DOC_IMG_FILE,
    docx: DOC_IMG_FILE,
  };

  return map[ext] || DOC_IMG_FILE; 
};
